import { cn } from "@/libs/cn";

const gridCols = "md:grid-cols-[3fr_3fr_4fr_2.6fr_2.4fr_2fr_2.8fr_3fr_3.4fr]";
const gridGap = "md:gap-4";
export const gridLayout = cn("flex flex-col gap-2 md:grid md:items-center", gridCols, gridGap, "px-4 md:px-6 py-3 md:py-2");

export const SKELETON_COLUMNS = 9;
export const LEADS_LIST_MIN_WIDTH = "md:min-w-[1600px]";

const LeadListHeader = () => {
  const headerStyle = "text-sm text-ui-navy-dark font-semibold text-gray-500 truncate";

  return (
    <div className={cn("hidden md:grid md:items-center", gridCols, gridGap, "bg-white border-b border-gray-100 px-6 py-4")}>
      <span className={headerStyle}>Nome</span>
      <span className={headerStyle}>Empresa</span>
      <span className={headerStyle}>E-mail</span>
      <span className={headerStyle}>Telefone</span>
      <span className={headerStyle}>Segmento</span>
      <span className={headerStyle}>Origem</span>
      <span className={headerStyle}>Recebido em</span>
      <span className={headerStyle}>Responsável</span>
      <span className={headerStyle}>Status</span>
    </div>
  );
};

export default LeadListHeader;
